import { AnalyticsContext } from '@carvana/eventable-clickstream';
import { useContext, useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import TransitChargeState from '~/constants/TransitChargeState';
import {
  getAnalytics,
  getGeoLocation,
  getIsLoggedIn,
  getSoonestRoute,
  getTransitChargeInfo,
  getVehicle
} from '~/selectors';

export default function useSendTransitCharge(): void {
  const { trackEvent } = useContext(AnalyticsContext);
  const { correspondingSearchRequestId } = useSelector(getAnalytics);
  const { zip } = useSelector(getGeoLocation);
  const isLoggedIn = useSelector(getIsLoggedIn);
  const soonestRoute = useSelector(getSoonestRoute);
  const transitCharge = useSelector(getTransitChargeInfo);
  const {
    details: { location: { locationId } = {} },
    transitActivityType,
    transitRouteId
  } = useSelector(getVehicle);

  const isLoggedInRef = useRef(isLoggedIn);
  useEffect(() => {
    isLoggedInRef.current = isLoggedIn;
  }, [isLoggedIn]);

  const activityTypeRef = useRef(soonestRoute?.activityType);
  useEffect(() => {
    activityTypeRef.current = soonestRoute?.activityType;
  }, [soonestRoute?.activityType]);

  const servicingLocationIdRef = useRef(soonestRoute?.servicingLocationId);
  useEffect(() => {
    servicingLocationIdRef.current = soonestRoute?.servicingLocationId;
  }, [soonestRoute?.servicingLocationId]);

  const zipRef = useRef(zip);
  useEffect(() => {
    zipRef.current = zip;
  }, [zip]);

  useEffect(() => {
    if (transitCharge.state === TransitChargeState.Unknown) return;
    trackEvent('Transit Charge', {
      correspondingSearchRequestId,
      isLoggedIn: isLoggedInRef.current,
      locationId,
      servicingLocationId: servicingLocationIdRef.current ?? null,
      merchSelectedActivityType: activityTypeRef.current ?? null,
      routeId: transitRouteId,
      quoteSelectedActivityType: transitActivityType ?? null,
      transitCharge: transitCharge.data,
      zip: zipRef.current
    });
  }, [
    correspondingSearchRequestId,
    locationId,
    trackEvent,
    transitActivityType,
    transitCharge.data,
    transitCharge.state,
    transitRouteId
  ]);
}
